const getters = {
    searchParam: state => {
        return state.searchParam
    },
    
}
export default getters
